const TEMPORARY_PRODUCT_ID_PREFIX = 'new-'
const PERSISTED_PRODUCT_ID_SLUG_SUFFIX_PATTERN =
  /^(?:[a-z0-9]{8,12}|[a-z0-9]*[a-z][a-z0-9]{12,}|[0-9]{16,})$/i

export const isTemporaryProductIdentity = (value: unknown): value is string =>
  typeof value === 'string' && value.startsWith(TEMPORARY_PRODUCT_ID_PREFIX)

export const hasTemporaryProductSlugIdentity = (
  value: unknown,
): value is string => {
  if (typeof value !== 'string') return false

  const slugParts = value.split('-').filter(Boolean)
  const lastPart = slugParts.at(-1)
  if (lastPart === 'new') return true

  const previousPart = slugParts.at(-2)
  return (
    previousPart === 'new' &&
    typeof lastPart === 'string' &&
    !PERSISTED_PRODUCT_ID_SLUG_SUFFIX_PATTERN.test(lastPart)
  )
}
